import React from 'react';

export default function MainNavCartIcon() {
  

  return (
    <svg 
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16.71 14.11"
        className="cart-icon"
      >
        <path 
          class="st0"
          d="M12.98,8.15L5.86,8.48l0.37,1.09h7.51c0.27,0,0.5,0.22,0.5,0.5c0,0.27-0.22,0.5-0.5,0.5H5.88
          c-0.21,0-0.4-0.14-0.47-0.34L2.5,1.67H0.93c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h1.93c0.21,0,0.4,0.14,0.47,0.34l2.2,6.48
          l7.1-0.33l1.87-4.01H5.38c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h9.9c0.17,0,0.33,0.09,0.42,0.23c0.09,0.14,0.1,0.32,0.03,0.48
          L13.4,7.87C13.33,8.03,13.16,8.14,12.98,8.15z M7.49,12.1c0,0.73-0.6,1.33-1.33,1.33c-0.73,0-1.33-0.6-1.33-1.33
          c0-0.73,0.6-1.33,1.33-1.33C6.89,10.77,7.49,11.37,7.49,12.1z M6.49,12.1c0-0.18-0.15-0.33-0.33-0.33s-0.33,0.15-0.33,0.33
          s0.15,0.33,0.33,0.33S6.49,12.29,6.49,12.1z M14.24,12.1c0,0.73-0.6,1.33-1.33,1.33c-0.73,0-1.33-0.6-1.33-1.33
          c0-0.73,0.6-1.33,1.33-1.33C13.65,10.77,14.24,11.37,14.24,12.1z M13.25,12.1c0-0.18-0.15-0.33-0.33-0.33
          c-0.18,0-0.33,0.15-0.33,0.33s0.15,0.33,0.33,0.33C13.1,12.44,13.25,12.29,13.25,12.1z"
        />
      </svg>
  );
}